export default __webpack_public_path__ + "static/media/h.47e58cf1.svg";